import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../../../../api';
import { HOME_TOPIC_ID, ITEM_TYPE, MAIN_SECTIONS, ROUTING, PATH } from '../../../../constants';
import './HomeLine.css';
import HomeLineItem from './HomeLineItem/HomeLineItem';
import * as textHelper from '../../../../utils/TextHelper';
import { connect } from 'react-redux';

// todo - show some 'fetching' state? or at least set final height

class HomeLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      labelData: {},
      lineContent: [],
      linePosition: 0,
      lineEnd: false,
    };

    this.arrowClickLeft = this.arrowClickLeft.bind(this);
    this.arrowClickRight = this.arrowClickRight.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentDidMount() {
    this.fetchLineData();
  }

  shouldComponentUpdate(nextProps) {
    if (this.state.lineContent.length > 0 && this.props.grid !== nextProps.grid) {
      this.lineMoveUpdate(
        this.state.linePosition,
        this.getContentLength() - nextProps.grid,
      );
    }
    return true;
  }

  // -------------------------------------------------------
  // Label
  // -------------------------------------------------------

  getTopicLabel() {
    const { hint, image, date, title } = this.state.labelData;
    return (
      <div className="label">
        <div className="label-wrap">
          <div className="hint-topic">{hint}</div>
          <img
            src={`${PATH.DATA}home/${image}.png`}
            alt=""
          />
          <div className="date">{date}</div>
          <div className="title-topic" dangerouslySetInnerHTML={{ __html: textHelper.formatText(title) }} />
        </div>
      </div>
    );
  }

  getNormalLabel() {
    const { range, title } = this.state.labelData;
    return (
      <div className="label">
        <Link
          className="label-wrap"
          to={`${ROUTING.CATEGORY}/${this.props.lineId}`}
        >
          <img
            src={`${PATH.IMG}homepage/ico-home-line-${this.props.lineId}.png`}
            alt=""
          />
          <div className="range">{range}</div>
          <div className="title">{textHelper.formatText(title)}</div>
        </Link>
      </div>
    );
  }
  getLabel() {
    if (this.props.lineId === HOME_TOPIC_ID) {
      return this.getTopicLabel();
    }
    return this.getNormalLabel();
  }

  // -------------------------------------------------------
  // Content
  // -------------------------------------------------------

  getContent() {
    const { grid, lineId } = this.props;
    const lineOffset = `${-(100 / grid) * this.state.linePosition}%`;

    // items
    const items = this.state.lineContent.map((item, index) => (
      <HomeLineItem
        key={`${lineId}-${item[0]}`}
        grid={grid}
        topic={lineId === HOME_TOPIC_ID}
        itemData={item}
        marginLeft={(index === 0) ? lineOffset : 0}
      />
    ));

    return (
      <div className="items">
        <div className="items-wrap">
          {items}
          {this.props.lineId !== HOME_TOPIC_ID &&
          <HomeLineItem
            grid={grid}
            topic={false}
            itemData={this.getCategoryItemData()}
            marginLeft={0}
          />
          }
        </div>
      </div>
    );
  }

  getCategoryItemData() {
    return ([
      '', {
        type: ITEM_TYPE.CATEGORY,
        categoryId: this.props.lineId,
      },
    ]);
  }

  getContentLength() {
    if (this.props.lineId === HOME_TOPIC_ID) {
      return this.state.lineContent.length;
    }
    return this.state.lineContent.length + 1; // +1 because of link at the end of each line
  }

  // -------------------------------------------------------
  // Arrows
  // -------------------------------------------------------

  getArrowLeft() {
    return (
      <div className="arrow-wrap left">
        <button
          className="arrow"
          disabled={this.state.linePosition === 0}
          onClick={this.arrowClickLeft}
        >
          <img
            src={`${PATH.IMG}homepage/home-arrow-${this.props.lineId === HOME_TOPIC_ID ? 0 : 1}-L.png`}
            alt="Předchozí"
          />
        </button>
      </div>
    );
  }

  getArrowRight() {
    return (
      <div className="arrow-wrap right">
        <button
          className="arrow"
          disabled={this.state.lineEnd}
          onClick={this.arrowClickRight}
        >
          <img
            src={`${PATH.IMG}homepage/home-arrow-${this.props.lineId === HOME_TOPIC_ID ? 0 : 1}-R.png`}
            alt="Další"
          />
        </button>
      </div>
    );
  }

  arrowClickLeft() {
    if (this.state.linePosition > 0) {
      this.lineMoveUpdate(
        this.state.linePosition - 1,
        this.getContentLength() - this.props.grid,
      );
    }
  }

  arrowClickRight() {
    if (!this.state.lineEnd) {
      this.lineMoveUpdate(
        this.state.linePosition + 1,
        this.getContentLength() - this.props.grid,
      );
    }
  }

  lineMoveUpdate(newId, endId) {
    const isEnd = newId >= endId;
    this.setState({
      linePosition: isEnd ? endId : newId,
      lineEnd: isEnd,
    });
  }

  // -------------------------------------------------------
  // Fetch
  // -------------------------------------------------------

  fetchLineData() {
    const { lineId, date } = this.props;
    if (lineId < HOME_TOPIC_ID) {
      // static content
      this.setState({
        fetching: false,
        labelData: MAIN_SECTIONS[lineId],
        lineContent: api.getHomeLineData(lineId),
      });
    } else {
      // topic
      const topicData = api.getHomeTopicLineData(date);
      this.setState({
        fetching: false,
        labelData: topicData.label,
        lineContent: topicData.lineData,
      }, () => {
        // todo - small hack - kind of not really ideal
        this.lineMoveUpdate(
          this.state.linePosition,
          this.getContentLength() - this.props.grid,
        );
      });
    }
  }


  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    let mainClass = 'home-line';
    if (this.props.lineId === HOME_TOPIC_ID) {
      mainClass = `${mainClass} top-topic`;
    } else {
      mainClass = `${mainClass} category`;
    }

    return (
      <div className={mainClass}>
        <div className="wrap">
          {!this.state.fetching &&
          <React.Fragment>
            {this.getLabel()}
            {this.getArrowLeft()}
            {this.getContent()}
            {this.getArrowRight()}
          </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  date: state.resize.date,
});

export default connect(mapStateToProps)(HomeLine);



// WEBPACK FOOTER //
// ./src/components/App/Home/HomeLine/HomeLine.js